import React, { useEffect, useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import HttpClient from '../../../utils/HttpClient';

const ViewComments = ({ strings, metadata }) => {

    const editorRef = useRef(null);
    const [editorContent, setEditorContent] = useState('');
    const HEADER = "<!DOCTYPE html><html><body>";
    const FOOTER = "</body></html>";



    const getTitle = () => metadata.Title?.value ?? metadata.Name?.value ?? metadata[strings['Filename']].value ?? "document";

    const saveLocalAndRestAPI = async () => {
        if (editorRef.current) {
            const documentTitle = getTitle();
            const editor = editorRef.current.getEditor();
            let content = editor.root.innerHTML;
            content = HEADER + content + FOOTER;
            console.log("content", content);
            //const file = new File([content], `${documentTitle}_comment.html`, { type: 'text/html' });
            //console.log("file", file);

            /*
            let date = new Date();
            const offset = date.getTimezoneOffset()
            date = new Date(date.getTime() - (offset * 60 * 1000))

            const meta = {
                type: "Comment",
                Titel: `${documentTitle}_comment`,
                Datum: date.toISOString().split('T')[0],
                isEditable: true,
            };
            */
            const httpClient = new HttpClient();
            try {
                await httpClient.comment(metadata.id.value, content);
            } catch (error) {
                console.error("Failed to save comment: " + JSON.stringify(error));
                alert("Failed to save comment");
            }
        }
    };

    const setContentOnInit = async () => {
        const httpClient = new HttpClient();
        try {
            const comment = await httpClient.getComment(metadata.id.value);
            setEditorContent(comment);
        } catch (error) {
            setEditorContent('<p></p>');
        }
    }

    useEffect(() => {
        setContentOnInit();
    }, [metadata]);
            /*
        setTimeout(() => {
            try {
                console.log("comment", comment);
                if (comment?.text) {
                    editorRef.current.setContent(comment.text);
                }
                else {
                    editorRef.current.setContent('<p></p>')
                }
            }
            catch (error) {
                editorRef.current.setContent('<p>Something unexpected happened with the editor. Please contact support.</p>')
                console.error("setContentOnInit error", error);
            }
        }, 0);
        */

    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'align': [] }],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'indent': '-1'}, { 'indent': '+1' }],
            ['link', 'image'],
            ['clean']
        ]
    };

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'color', 'background',
        'align',
        'list', 'bullet',
        'indent',
        'link', 'image'
    ];

    const getComments = () => {
        return (
            <div>
                <ReactQuill 
                    ref={editorRef}
                    theme="snow"
                    value={editorContent}
                    onChange={setEditorContent}
                    modules={modules}
                    formats={formats}
                    style={{ height: '400px', marginBottom: '50px' }}
                />
                <button onClick={saveLocalAndRestAPI}>Spara i TinyDS</button>
            </div>
        )
    }
    return getComments();
}

export default ViewComments;